import React from "react";

export default function Menu() {
  return (
<div className="grid grid-cols-[2fr_1fr_1fr_1fr] text-xs font-semibold text-[var(--text)] px-4 py-2 border-b-2 border-[var(--hover)]">
  <span className="text-left">Symbol</span>
  <span className="text-right">Bid</span>
  <span className="text-right">Ask</span>
  <span className="text-right">Day %</span>
</div>

  );
}
